import { fetchSyteBuildingData } from '@/api/mfh/syte.api';
import type { ISyteResult } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { isAxiosError } from 'axios';
import { computed, type MaybeRef, unref } from 'vue';

export const useSyteBuildingData = (mfhId: MaybeRef<number>, enabled: MaybeRef<boolean> = true) => {
    const isEnabled = computed(() => {
        const id = unref(mfhId);
        return Boolean(unref(enabled)) && Number.isFinite(id) && id > 0;
    });

    return useQuery(
        computed(() => ['syte-building', unref(mfhId)]),
        async (): Promise<ISyteResult | null> => {
            const id = unref(mfhId);
            try {
                return await fetchSyteBuildingData(id);
            } catch (error) {
                if (isAxiosError(error) && error.response?.status === 404) {
                    return null;
                }
                throw error;
            }
        },
        {
            staleTime: 24 * 60 * 60 * 1000,
            retry: false,
            enabled: isEnabled,
        },
    );
};
